import WKT from 'ol/format/WKT';
import { createEmpty, extend, getCenter } from 'ol/extent';
import { transform } from 'ol/proj';
import { Coordinate } from '../models/coordinate.model';

export const calculateCenterFromWktStrings = (wktStrings: string[]): Coordinate => {
  const wktFormat = new WKT();
  let extentGlobale = createEmpty();

  wktStrings.forEach(wkt => {
    const geometry = wktFormat.readGeometry(wkt, {
      dataProjection: 'EPSG:4326',
      featureProjection: 'EPSG:3857'
    });
    extend(extentGlobale, geometry.getExtent());
  });

  const centroMercatore = getCenter(extentGlobale);

  // Trasforma il centro da EPSG:3857 (metri) a EPSG:4326 (gradi)
  const [lng, lat] = transform(centroMercatore, 'EPSG:3857', 'EPSG:4326');

  return { latitudine: lat, longitudine: lng };
}



export const calculateCenterFromCoordinates = (punti: Coordinate[]): Coordinate => {
  let extentGlobale = createEmpty();

  punti.forEach(punto => {
    // Trasforma ogni punto da EPSG:4326 (lat/lng) a EPSG:3857 (metri) 
    // perché le funzioni di OpenLayers lavorano in coordinate proiettate
    const coordMercatore = transform([punto.longitudine, punto.latitudine], 'EPSG:4326', 'EPSG:3857');
    
    // Estendi l'extent includendo il punto
    // Un punto è un extent che inizia e finisce nello stesso posto
    extend(extentGlobale, [coordMercatore[0], coordMercatore[1], coordMercatore[0], coordMercatore[1]]);
  });

  // 3. Calcola il centro dell'extent in metri
  const centroMercatore = getCenter(extentGlobale);

  // 4. Trasforma il centro finale di nuovo in gradi (EPSG:4326)
  const [lng, lat] = transform(centroMercatore, 'EPSG:3857', 'EPSG:4326');

  return { latitudine: lat, longitudine: lng };
}